import { c as _c } from "react/compiler-runtime";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { STATEMENT_GROUP, STATEMENT_TYPE } from "@/helpers/Types";
import UserPageIdentityAddStatementsSocialMediaPostsHeader from "./UserPageIdentityAddStatementsSocialMediaPostsHeader";
import UserPageIdentityAddStatementsForm from "@/components/user/identity/statements/utils/UserPageIdentityAddStatementsForm";
export default function UserPageIdentityAddStatementsSocialMediaPosts(t0) {
  const $ = _c(8);
  const {
    profile,
    onClose
  } = t0;
  let t1;
  if ($[0] !== onClose) {
    t1 = <UserPageIdentityAddStatementsSocialMediaPostsHeader onClose={onClose} />;
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onClose || $[3] !== profile) {
    t2 = <UserPageIdentityAddStatementsForm profile={profile} activeType={STATEMENT_TYPE.LINK} group={STATEMENT_GROUP.SOCIAL_MEDIA_VERIFICATION_POST} onClose={onClose} />;
    $[2] = onClose;
    $[3] = profile;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}